import { NEW_CARD_OPTION, type JourneyAddedCard } from '~/components/JourneyPayment/types';
import type { BrazilAddressFields } from '~/utils/brazilAddress';

/** Corpo de `PUT Contracts/quotes/{quoteId}/renew` (mesmo contrato do legado). */
export type RenewalPayload = {
  hash_card?: string;
  card_id?: string;
  tax_address: BrazilAddressFields;
  organization_id: string;
};

/** `data` da resposta do `renew`. */
export type RenewalResult = {
  contract_id: string;
  contract_code: string;
  is_renew_outdated: boolean;
};

/**
 * Desfecho do pagamento. `analysis` («em análise pela seguradora», Figma 2096:5480) depende de um sinal da
 * API ainda não definido (CORE-988); até lá, o `renew` aprovado é sempre `success`.
 */
export type RenewalOutcome = 'success' | 'analysis' | 'outdated' | 'failure';

const withDigitsZipcode = (address: BrazilAddressFields): BrazilAddressFields => ({
  ...address,
  zipcode: address.zipcode.replace(/\D/g, '')
});

/**
 * Cartão novo → `hash_card` (token do Pagar.me gerado **agora**, `newCardToken`) e o endereço de cobrança
 * informado com ele; cartão salvo → `card_id` e o endereço do contrato. Sempre com `organization_id`.
 * Sem cartão escolhido (ou cartão novo sem token), `null`.
 */
export function buildRenewalPayload({
  selectedId,
  addedCards,
  contractAddress,
  organizationId,
  newCardToken
}: {
  selectedId: string | null;
  addedCards: JourneyAddedCard[];
  contractAddress: BrazilAddressFields;
  organizationId: string;
  newCardToken?: string;
}): RenewalPayload | null {
  if (!selectedId || selectedId === NEW_CARD_OPTION) return null;
  const added = addedCards.find((card) => card.id === selectedId);
  if (added) {
    if (!newCardToken) return null;
    return {
      hash_card: newCardToken,
      tax_address: withDigitsZipcode(added.billingAddress),
      organization_id: organizationId
    };
  }
  return { card_id: selectedId, tax_address: contractAddress, organization_id: organizationId };
}

export function getRenewalOutcome(result: RenewalResult | undefined | null): Exclude<RenewalOutcome, 'failure'> {
  return result?.is_renew_outdated ? 'outdated' : 'success';
}
